import React, { useState, useEffect, useRef, useCallback } from "react";
import "./AddEntryEmployee.css";

import { Typography, Sheet, Box, FormControl, FormLabel, Button, FormHelperText, Switch, CircularProgress, CssVarsProvider } from "@mui/joy";
import { AddNewEntryProps, IVendorList } from "../../utils/types";
import { AssignedTypeOptions, billCategoryInvoiceOptions, billCategoryOptions, billTypeOptions, muiThemeFinal, paymentsTrandsOption, procurementTypeOptions, throughGEMOptions } from "../../utils/constants";
import { SelectInput, TextareaInput, TextInput } from "../../utils/input";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useGetEmployeeInvoiceDetailsQuery,
  useGetInvoiceDetailsQuery,
  useHandleEmployeeInvoiceEntryMutation,
  useUploadForExtractionMutation,
  useLazyGetExtractionStatusQuery,
  useLazyGetExtractionResultQuery,
  useGetTredsPaymentsDetailsQuery,
  useGetTredsDetailsQuery,
  useGetTredsListOdataQuery,
} from "../../services/invoices/InvoiceApiSlice";
import PoSelectionDropdown from "../PoSelectionDropdown";
import EmployeeSidebar from "../EmployeeSidebar";
import { Accordion, AccordionDetails, AccordionSummary, CssBaseline } from "@mui/material";
import useAddEntryForm from "../../hooks/useAddEntryForm";
import { toast, ToastContainer } from "react-toastify";
import SuccessModal from "../Common/SuccessModal";
import AttachmentTable from "./AttachmentTable";
import { formatDateForInput, formatIndianCurrency } from "../../utils/utils";

import BtsFinancialDetailsSection from "./BtsFinancialDetailsSection";
import DivisionDropdown from "./DivisionDropdown";
import LocationDropdown from "./LocationDropdown";
import { useGetFiEmpHodMutation } from "../../services/vendor/VendorApi";
import OtherAttachments from "./OtherAttachments";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ApprovalLogsDrowdown from "../Employee/ApproverPage/ApprovalLogsDrowdown";
import { ThemeProvider as MaterialThemeProvider } from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";
import FeedbackModals from "../Employee/ApproverPage/FeedbackModals";
import ExtractionReviewModal, { ExtractionValues } from "./ExtractionReviewModal";



/**
 * A safe helper function to extract the invoice ID from the bts_no string in location state.
 */
const getInvoiceIdFromState = (locationState: any): string | null => {
  const bts_no = locationState?.invoiceData?.bts_no;
  if (typeof bts_no === "string" && bts_no.includes("-")) {
    return bts_no.split("-")[0];
  }
  return null;
};


export const AddEntryEmployee: React.FC<AddNewEntryProps> = ({ employee }) => {

  const [isOpenFeedbackModal, setIsOpenFeedbackModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [emphodList, setEmpHodList] = useState<any>([]);
  var { id: routeIdParam1 } = useParams<{ id: string }>();
  var routeIdParam = atob(atob(routeIdParam1 ?? ''));
  const { validateForm, initialDocumentsData, sectionHeaderStyles, handleFileDownload, handleCurrencyOnBlur } = useAddEntryForm();



  const [successModalOpen, setSuccessModalOpen] = useState<{
    open: boolean;
    title?: string;
    description?: string;
  }>({
    open: false,
    title: "",
    description: "",
  });

  const [getFiEmpHodData] = useGetFiEmpHodMutation();

  const { id } = useParams<{ id?: string }>();
  // const matchResult = id?.match(/^([^-]+)/)?.[1]; // The `?.[1]` is key!
  const matchResult = atob(atob(id ?? '')); // The `?.[1]` is key!

  // If matchResult is found, use it. Otherwise, fall back to the original id.
  const btsNo = matchResult || id;


  const isEditMode = !!id;

  const isReadOnly = location.state?.isReadOnly ?? false;
  const {
    data: invoiceDetails,
    isLoading: isLoadingDetails,
    isError: isDetailsError,
  } = useGetInvoiceDetailsQuery(btsNo!, {
    skip: !btsNo,
  });

  const { data: tredsDetails } = useGetTredsDetailsQuery(btsNo, { skip: !btsNo })

  const [handleEmployeeInvoiceEntry, { isLoading: isSubmittingEmployeeEntry }] = useHandleEmployeeInvoiceEntryMutation();
  const [uploadForExtraction] = useUploadForExtractionMutation();
  const [fetchExtractionStatus] = useLazyGetExtractionStatusQuery();
  const [fetchExtractionResult] = useLazyGetExtractionResultQuery();

  const [extractState, setExtractState] = useState<{
    status: "idle" | "uploading" | "done" | "failed";
    extractedData: { fields: Record<string, any>; confidence: Record<string, any>; original_filename?: string } | null;
    pdfFile: File | null;
    modalOpen: boolean;
    errorMsg: string | null;
  }>({
    status: "idle",
    extractedData: null,
    pdfFile: null,
    modalOpen: false,
    errorMsg: null,
  });

  const handleExtractionConfirm = useCallback((values: ExtractionValues) => {
    setFormData((prev) => ({
      ...prev,
      billNo: values.invoice_number,
      billDate: values.invoice_date,
      grossAmount: values.base_amount,
      totalTax: values.total_tax,
      billAmount: values.invoice_amount,
      netPayable: values.net_payable,
    }));
    setExtractState((prev) => ({ ...prev, modalOpen: false }));
    toast.success("Invoice details prefilled from extracted data.");
  }, []);

  const handleExtractionCancel = useCallback(() => {
    setExtractState((prev) => ({ ...prev, modalOpen: false }));
  }, []);

  // --- 3. Component State Initialization ---
  var initialStateObj = {
    attachment: null,
    attachmentPreview: null,
    throughGEM: "",
    assignedTo: "",
    assignedToName: "",
    gemContactNo: "",
    billType: "",
    billCategory: "",
    procurementType: "",
    poContract: "",
    vendor_code: "",
    vendor_name: "",
    dakNo: "",
    treds_payment: '',
    invoiceForWhichLocation: "",
    divisionName: "",
    remarks: "",
    btsNo: "System Generated",
    btsEntryDate: new Date().toISOString().slice(0, 10),
    grossAmount: "",
    billDate: "",
    totalTax: "",
    billAmount: "",
    billNo: "",
    advanceAdj: "",
    netPayable: "",
    isPoModuleSelected: "Yes",
    documents: initialDocumentsData.map((doc) => ({ ...doc })),
    org_type: "",
    poContractDetails: {
      plant: "",
      created_by: "",
      pending_with: "",
      responsible_person: "",
    },
    gem_type: "",
    othersAttachments: []
  };

  const [formData, setFormData] = useState<any>({ ...initialStateObj });
  const [trendsCodeList, setTrendsCodeList] = useState<any>([]);
  const { data: tradsPaymentist } = useGetTredsPaymentsDetailsQuery(formData?.vendor_code, { skip: formData?.vendor_code === '' });
  const { data: tradsListOdata } = useGetTredsListOdataQuery(formData?.poContractDetails?.ebeln, { skip: !formData?.poContractDetails?.ebeln });


  useEffect(() => {
    if (tradsPaymentist) {
      let arr1 = [];
      tradsPaymentist?.d?.results?.map((item) => arr1.push({ value: item?.Ztresdcode, label: item?.Ztresdcode }))
      setTrendsCodeList([...arr1]);


      setTimeout(() => {
        console.log(invoiceDetails?.treds_payment)
        setFormData((prev) => ({ ...prev, treds_payment: invoiceDetails?.treds_payment ?? "" }))
      }, 1000);
    }
  }, [tradsPaymentist]);

  useEffect(() => {
    if (isEditMode && invoiceDetails) {
      const createDataUrl = (data: string | null, mime: string | null): string | null => {
        return data && mime ? `data:${mime};base64,${data}` : null;
      };

      setFormData((prev) => ({
        ...prev,
        vendor_code: invoiceDetails.vendor_code ?? "",
        vendor_name: invoiceDetails.vendor_name ?? "",
        remarks: invoiceDetails.Remarks ?? "",
        throughGEM: invoiceDetails.gem_option ?? "",
        gemContactNo: invoiceDetails.gem_contact ?? "",
        advanceAdj: invoiceDetails.advance_adj ?? "",
        billAmount: invoiceDetails.bill_amount ?? "",
        billCategory: invoiceDetails.bill_category ?? "",
        billDate: formatDateForInput(invoiceDetails.bill_date),
        billType: invoiceDetails.bill_type ?? "",
        btsEntryDate: formatDateForInput(invoiceDetails.bts_entry_date),
        btsNo: invoiceDetails.bts_no ?? "System Generated",
        dakNo: invoiceDetails.dak_no ?? "",
        treds_payment: invoiceDetails?.treds_payment ?? "",
        divisionName: invoiceDetails.division_name ?? "",
        grossAmount: invoiceDetails.gross_amount ?? "",
        invoiceForWhichLocation: invoiceDetails.invoice_location ?? "",
        netPayable: invoiceDetails.net_payable ?? "",
        poContract: invoiceDetails.po_contract ?? "",
        assignedTo: invoiceDetails.pending_with ?? "",
        procurementType: invoiceDetails.procurement_type ?? "",
        totalTax: invoiceDetails.total_tax ?? "",
        billNo: invoiceDetails.challan_no ?? "",
        attachment: null,
        existingAttachmentName: invoiceDetails.attachment_name, // Store existing file name
        attachmentPreview: createDataUrl(invoiceDetails.attachment_data, invoiceDetails.attachment_mime),
        poContractDetails: {
          plant: invoiceDetails?.plant,
          created_by: invoiceDetails?.created_by,
          pending_with: invoiceDetails?.pending_with,
          responsible_person: invoiceDetails?.responsible_person,
        },
        documents: initialDocumentsData.map((doc) => {
          if (doc.description.toLowerCase().includes("labor")) {
            return {
              ...doc,
              file: null,
              existingFileName: invoiceDetails.labor_name,
            };
          }
          if (doc.description.toLowerCase().includes("work completion")) {
            return {
              ...doc,
              file: null,
              existingFileName: invoiceDetails.workcert_name,
            };
          }
          return { ...doc };
        }),
        isPoModuleSelected: invoiceDetails.entry_type === "MM" ? "Yes" : "No",
        approver_remarks: invoiceDetails?.approver_remarks ?? "",
        gem_type: invoiceDetails?.gem_type ?? "",
        gem_attachment_name: invoiceDetails?.gem_attachment_name ?? "",
        othersAttachments: [...invoiceDetails?.othersAttachments || []],
      }));
    }
  }, [invoiceDetails, isEditMode, employee]);

  const { data: billsData } = useGetEmployeeInvoiceDetailsQuery(routeIdParam!, {
    skip: !routeIdParam,
    refetchOnMountOrArgChange: true,
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (["grossAmount", "totalTax"]?.includes(e.target.name)) {
      setFormData((prev) => {
        const updatedValue = Number(e.target.value.replace(/,/g, ""));
        const totalTax = Number(prev?.totalTax.replace(/,/g, ""));
        const grossAmount = Number(prev?.grossAmount.replace(/,/g, ""));

        const updatedBillAmount = e.target.name === "grossAmount" ? String(totalTax + updatedValue) : String(grossAmount + updatedValue);
        const updatedNetPayable = String(Number(updatedBillAmount) - Number(prev?.advanceAdj));

        return {
          ...prev,
          [e.target.name]: e.target.value,
          billAmount: formatIndianCurrency(updatedBillAmount),
          netPayable: formatIndianCurrency(updatedNetPayable),
        };
      });
    } else if (e.target.name === "billAmount") {
      setFormData((prev) => {
        const advanceAdj = Number(prev?.advanceAdj.replace(/,/g, ""));
        const target = Number(e.target.value.replace(/,/g, ""));

        return {
          ...prev,
          [e.target.name]: e.target.value,
          netPayable: formatIndianCurrency(String(target - advanceAdj)),
        };
      });
    } else if (e.target.name === "advanceAdj") {
      setFormData((prev) => {
        const billAmount = Number(prev?.billAmount.replace(/,/g, ""));
        const target = Number(e.target.value.replace(/,/g, ""));
        return {
          ...prev,
          [e.target.name]: e.target.value,
          netPayable: formatIndianCurrency(String(billAmount - target)),
        };
      });
    } else {
      setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }
  };

  const handleSelectChange = (name: string, valueObj: string | { label: string; value: string } | null) => {
    var finalValueToSet = typeof valueObj === "string" ? valueObj : valueObj ? valueObj.value : "";

    if (name === "invoiceForWhichLocation") {
      setFormData((prev) => ({
        ...prev,
        invoiceForWhichLocation: (valueObj as { label: string; value: string })?.value,
        location_name: (valueObj as { label: string; value: string })?.label,
      }));
    } else if (name === "procurementType") {
      setFormData((prev) => ({
        ...prev,
        [name]: finalValueToSet,
        divisionName: "",
        invoiceForWhichLocation: "",
        poContract: "",
        poContractDetails: null,
      }));
    } else if (name === "throughGEM") {
      setFormData((prev) => ({
        ...prev,
        gemContactNo: "",
        dakNo: "",
        [name]: finalValueToSet,
      }));
    } else {
      if (name === "invoiceForWhichLocation" && isEditMode) {
        finalValueToSet = formData.invoiceForWhichLocation;
      }
      if (name === "divisionName" && isEditMode) {
        finalValueToSet = formData.divisionName;
      }
      var assignedTo =
        (name === "invoiceForWhichLocation" || name === "divisionName") && formData?.isPoModuleSelected === "No"
          ? { assignedTo: "", org_type: "" }
          : { assignedTo: formData.assignedTo };
      setFormData((prev) => ({ ...prev, [name]: finalValueToSet, poContract: name === "procurementType" ? "" : formData.poContract, ...assignedTo }));
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, docId?: string) => {
    const file = e.target.files?.[0];
    const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSizeInBytes) {
      toast.error("File size exceeds 5 MB limit.");
      e.target.value = ""; // Clear the input
      return;
    }
    if (file && !["application/pdf"].includes(file.type)) {
      toast.error("Only PDF file are allowed!");
      e.target.value = ""; // Clear the input
      return;
    }

    if (file) {
      if (docId) {
        setFormData((prev) => ({
          ...prev,
          documents: prev.documents.map((doc) => (doc.id === docId ? { ...doc, file, preview: URL.createObjectURL(file) } : doc)),
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          attachment: file,
          attachmentPreview: URL.createObjectURL(file),
        }));
        if (file.name.toLowerCase().endsWith(".pdf")) {
          // setExtractState({ status: "uploading", extractedData: null, pdfFile: file, modalOpen: false, errorMsg: null });
          // const fd = new FormData();
          // fd.append("file", file);
          // uploadForExtraction(fd)
          //   .unwrap()
          //   .then((res) => {
          //     setExtractState((prev) => ({
          //       ...prev,
          //       status: "done",
          //       extractedData: {
          //         fields: res.fields,
          //         confidence: res.confidence,
          //         original_filename: res.filename,
          //       },
          //       modalOpen: true,
          //     }));
          //     toast.success("Invoice extracted successfully!");
          //   })
          //   .catch((err) => {
          //     setExtractState((prev) => ({ ...prev, status: "idle", pdfFile: null }));
          //     const msg = err?.data?.message || err?.message || "Could not extract invoice. Please fill details manually.";
          //     toast.error(msg);
          //   });
        }
      }
    }
  };
  const handleOtherFileChange = async (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
    const file = e.target.files?.[0];
    const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSizeInBytes) {
      toast.error("File size exceeds 5 MB limit.");
      e.target.value = ""; // Clear the input
      return;
    }

    if (file && !["application/pdf"].includes(file.type)) {
      toast.error("Only PDF file are allowed!");
      e.target.value = ""; // Clear the input
      return;
    }

    var keys = ['attachment1', 'attachment2', 'attachment3', 'attachment4', 'attachment5'];

    if (file) {
      var fileObject = {
        file_key: keys[index],
        attachmentPreview: URL.createObjectURL(file),
        file_data: await fileToBase64(file),
        file_name: file?.name,
        file_type: file?.type,
        existingAttachmentName: true
      }
      var fileList = [...formData?.othersAttachments];
      fileList[index] = fileObject;
      setFormData((prev) => ({
        ...prev,
        othersAttachments: [...fileList],
      }));

    }
  };
  const handleOtherFileDownload = () => {

  }
  const onHandleDeleteRow = (index: any) => {
    var list = [...formData?.othersAttachments];
    list.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      othersAttachments: [...list],
    }));
  }

  const getDocumentFile = (description: string): File | null => {
    const docEntry = formData.documents.find((doc) => doc.description.toLowerCase() === description.toLowerCase());
    return docEntry && docEntry.file instanceof File ? docEntry.file : null;
  };

  const handlePoSelectChangePO = (event: React.SyntheticEvent | null, newValue: any) => {


    if (newValue?.created_by === '' || newValue?.responsible_person === '') {
      toast.error("Assignment is missing please contact concern devision.")
      return;
    }
    if (newValue) {
      setFormData((prev) => ({
        ...prev,
        poContract: newValue?.ebeln || "",
        poContractDetails: newValue,

      }));
    }
  };

  console.log(formData)
  const handlePoSelectChangeVendor = (event: React.SyntheticEvent | null, selectedPo: IVendorList) => {

    if (selectedPo) {

      setFormData((prev) => ({
        ...prev,
        vendor_code: selectedPo?.vendor_code,
        vendor_name: selectedPo?.username,
        poContract: "",
        procurementType: "",
        invoiceForWhichLocation: "",
        divisionName: "",
        approver_email: selectedPo?.email,
      }));
    }


  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        const base64String = result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  // --- 6. Unified Submission Handler ---
  const onFinalSubmit = async (actionType: "submit" | "draft") => {
    if (actionType === "submit") {
      const errors = validateForm(formData);


      if (errors && errors?.length > 0) {
        // setTimeout(() => toast1.error(errors[0]), 100);
        // // toast.error(errors[0]);
        errors.slice(0, 3).forEach((err) => toast.error(err));
        return;
      }
    }
    try {
      // --- 2. Construct the inner 'payload' object ---
      // const [num, name] = formData.poContract.split(' ');
      //created_by
      const innerPayload: any = {
        action: actionType,
        isPoModuleSelected: formData.isPoModuleSelected,
        gem_option: formData.throughGEM,
        gem_contact: formData.gemContactNo,
        bill_type: formData.billType,
        bill_category: formData.billCategory,
        procurement_type: formData.procurementType,
        po_contract: formData.poContract,
        invoice_location: formData.invoiceForWhichLocation,
        division_name: formData.divisionName,
        Remarks: formData.remarks,
        bill_No: formData.billNo,
        bill_date: formData.billDate,
        gross_amount: formData.grossAmount,
        total_tax: formData.totalTax,
        bill_amount: formData.billAmount,
        advance_adj: formData.advanceAdj || "0",
        net_payable: formData.netPayable,
        dak_no: formData.dakNo,
        treds_payment: formData.treds_payment,
        vendor_name: formData.vendor_name,
        vendor_code: formData.vendor_code,
        entry_type: employee && formData.isPoModuleSelected === "Yes" ? "MM" : "FI",
        status: "Pending",
        bts_entry_date: formData.btsEntryDate,
        org_type: formData.org_type,
        location_name: formData?.location_name,
        approver_email: "",
        othersAttachments: [...formData.othersAttachments],
      };
      if (innerPayload?.entry_type === "MM") {
        innerPayload.plant = formData?.poContractDetails?.plant ?? "";
        innerPayload.created_by = formData?.poContractDetails?.created_by ?? "";
        innerPayload.pending_with = formData?.poContractDetails?.responsible_person ?? "";
        innerPayload.pending_name = formData?.poContractDetails?.created_by ?? "";
        innerPayload.responsible_person = formData?.poContractDetails?.responsible_person ?? "";
        innerPayload.approver_email = formData?.poContractDetails?.email ?? "";
      } else {
        innerPayload.pending_with = formData?.assignedTo ?? "";
        innerPayload.pending_name = formData?.assignedToName ?? "";
        innerPayload.approver_email = formData?.approver_email ?? "";
      }
      innerPayload.created_by = localStorage.getItem("employee_id");
      innerPayload.created_name = localStorage.getItem("employee_name");
      // Conditionally add file data if new files were uploaded
      if (formData?.attachment instanceof File) {
        // If the user uploaded a new file
        innerPayload.attachment = await fileToBase64(formData?.attachment);
        innerPayload.attachment_name = formData?.attachment?.name;
        innerPayload.attachment_mime = formData?.attachment?.type;
      } else {
        // If no new file, ensure the keys exist but are null.
        // This is what solves the "Missing required fields" error.
        innerPayload.attachment = null;
        innerPayload.attachment_name = null;
        innerPayload.attachment_mime = null;
      }

      // --- 3. Handle the 'labor_license' field ---
      const laborFile = getDocumentFile("Labor License");
      if (laborFile) {
        innerPayload.labor_license = await fileToBase64(laborFile);
        innerPayload.labor_name = laborFile.name;
        innerPayload.labor_mime = laborFile.type;
      } else {
        innerPayload.labor_license = null;
        innerPayload.labor_name = null;
        innerPayload.labor_mime = null;
      }

      // --- 4. Handle the 'work_cert' field ---
      const workCertFile = getDocumentFile("Work Completion Certificate");
      if (workCertFile) {
        innerPayload.work_cert = await fileToBase64(workCertFile);
        innerPayload.workcert_name = workCertFile.name; // Note: key might be different
        innerPayload.workcert_mime = workCertFile.type;
      } else {
        innerPayload.work_cert = null;
        innerPayload.workcert_name = null;
        innerPayload.workcert_mime = null;
      }

      // --- 3. Construct the final top-level object ---
      const finalSubmissionObject = {
        payload: innerPayload,
        isUpdate: isEditMode,
      };

      // --- 4. Call the API mutation ---
      const response = await handleEmployeeInvoiceEntry(finalSubmissionObject).unwrap();

      if (response.success) {
        if (actionType === "submit") {
          toast.success(`Selected items sent for approval! BTS No.: ${response?.bts_no}`);
          setTimeout(() => {
            navigate("/employee-bills");
          }, 1000);

          // setIsOpenFeedbackModal(true);
          // setSuccessModalOpen({
          //   open: true,
          //   title: `Selected items sent for approval! BTS No.: ${response?.bts_no}`,
          // });
        } else {
          navigate("/employee-bills");
        }
      } else {
        toast.error(`Server Error: ${response.message || response?.data?.message}`);
      }
    } catch (err: any) {
      const errorMsg = err?.message || err?.data?.message;
      toast.error(`Submission Failed: ${errorMsg}`);
    }
  };

  const handleSubmit = () => onFinalSubmit("submit");
  const handleDraftSave = () => onFinalSubmit("draft");

  const isExtracting = extractState.status === "uploading";

  const getEmpAssignData = async () => {
    try {
      const response = await getFiEmpHodData("department_code=" + formData.divisionName + "&location_code=" + formData.invoiceForWhichLocation);
      if (response?.data?.d?.results) {
        var arr = response?.data?.d?.results;
        setEmpHodList([...emphodList, { value: arr[0].uname, label: arr[0]?.uname + "-" + arr[0].ename }]);
        setFormData({ ...formData, assignedTo: arr[0].uname, org_type: arr[0].org_type, approver_email: arr[0]?.email, assignedToName: arr[0].ename });
        //assignedToName
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getEmpAssignData();
    }
  }, [formData.divisionName]);

  useEffect(() => {
    if (location.pathname === "/employee/add-new-entry") {
      setFormData({ ...initialStateObj });
    }
  }, [location.pathname]);


  if (isEditMode && isLoadingDetails) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (isEditMode && isDetailsError) {
    return (
      <Typography color="danger" sx={{ p: 4, textAlign: "center" }}>
        Error loading invoice details.
      </Typography>
    );
  }

  // --- 7. Render the Form ---
  return (
    <>
      <ExtractionReviewModal
        open={extractState.modalOpen}
        extracted={extractState.extractedData}
        pdfFile={extractState.pdfFile}
        onConfirm={handleExtractionConfirm}
        onCancel={handleExtractionCancel}
      />
      <ToastContainer />
      <CssVarsProvider disableTransitionOnChange>
        <CssBaseline />
        <Box sx={{ display: "flex", minHeight: "92dvh", background: "white" }}>
          <EmployeeSidebar />

          <div className={`add-entry-outer ${!isEditMode ? "create-emp" : ""}`}>
            <Box
              sx={{
                p: { xs: 1.5, md: 2.5 },
                display: "flex",
                flexDirection: "column",
                gap: 2.5,
                pb: "130px",
              }}
            >
              {formData?.btsNo !== "System Generated" && (
                <Typography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
                  BTS No.: {formData?.btsNo.replace(/^0+/, "")}
                  <span className="info-text">(All values are in INR.)</span>
                </Typography>
              )}
              {/* <Typography level="body-xs" sx={{ color: "red" }}>
              All values are in INR.
              </Typography> */}
              <AttachmentTable
                formData={formData}
                btsNo={invoiceDetails?.bts_no}
                handleFileChange={handleFileChange}
                handleFileClick={handleFileDownload}
                isReadOnly={isReadOnly}
              />

              {isExtracting && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: 2,
                    py: 1.25,
                    borderRadius: "sm",
                    bgcolor: "#eff6ff",
                    border: "1px solid #bfdbfe",
                  }}
                >
                  <CircularProgress size="sm" color="primary" />
                  <Typography level="body-sm" sx={{ color: "#1d4ed8" }}>
                    {extractState.status === "uploading"
                      ? "Uploading invoice for extraction…"
                      : "Reading invoice details — this may take a few seconds…"}
                  </Typography>
                </Box>
              )}

              <FormControl orientation="horizontal" sx={{ width: "fit-content", justifyContent: "space-between", mx: "auto", gap: 2 }}>
                <Box>
                  <FormLabel sx={{ mr: 0 }}>without PO/Contract</FormLabel>
                  <FormHelperText sx={{ mt: 0 }}>FI module</FormHelperText>
                </Box>
                <Switch
                  checked={formData.isPoModuleSelected === "Yes"}
                  onChange={(e) => {

                    setIsOpen(!e.target.checked);
                    setFormData({
                      ...formData,
                      isPoModuleSelected: e.target.checked ? "Yes" : "No",
                    });
                  }}
                  color={formData.isPoModuleSelected === "Yes" ? "success" : "neutral"}
                  variant="solid"
                  disabled={isReadOnly}
                  slotProps={{
                    thumb: {
                      children: formData.isPoModuleSelected === "Yes" ? "Yes" : "No",
                    },
                  }}
                  sx={{
                    "--Switch-thumbSize": "28px",
                    "--Switch-trackWidth": "64px",
                    "--Switch-trackHeight": "32px",
                  }}
                />
                <Box>
                  <FormLabel>with PO/Contract</FormLabel>
                  <FormHelperText sx={{ mt: 0 }}>MM module</FormHelperText>
                </Box>
              </FormControl>

              <Sheet variant="outlined" sx={{ p: 0, borderRadius: "sm", overflow: "hidden" }}>
                <Typography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
                  Header Details
                </Typography>
                <Box
                  sx={{
                    p: 2,
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "1fr 1fr",
                      md: "1fr 1fr 1fr",
                      lg: "1fr 1fr 1fr 1fr",
                    },
                    gap: 2,
                  }}
                  className="add-employee-form"
                >
                  {/* Select a Vendor */}
                  <PoSelectionDropdown
                    value={formData?.vendor_code}
                    onChange={handlePoSelectChangeVendor}
                    // required={formData?.isPoModuleSelected === "Yes"}
                    disabled={isReadOnly}
                    module={formData?.isPoModuleSelected}
                    user="employee"
                  />
                  {!isOpen && (
                    <SelectInput
                      name="assignedTo"
                      label="Assign To"
                      value={formData.assignedTo}
                      onChange={handleSelectChange}
                      options={AssignedTypeOptions}
                      placeholder="Assign To"
                      disabled={isReadOnly || formData.isPoModuleSelected === "Yes"}
                      required={formData.isPoModuleSelected === "No"}
                    />
                  )}
                  <SelectInput
                    name="throughGEM"
                    label="Through Portal ?"
                    value={formData.throughGEM}
                    onChange={handleSelectChange}
                    options={throughGEMOptions}
                    placeholder="Select"
                    disabled={isReadOnly || formData.isPoModuleSelected === "No"}
                  />
                  <TextInput
                    name="gemContactNo"
                    label="Portal Contract No"
                    value={formData.gemContactNo}
                    onChange={handleInputChange}
                    placeholder={formData.throughGEM !== "no" ? `Enter ${formData.throughGEM ? formData.throughGEM : "GEM"} Contract No.` : "Enter GEM Contract No."}
                    required={["gem", "tender_wizard", "nic"]?.includes(formData.throughGEM) && formData.isPoModuleSelected === "Yes"}
                    disabled={isReadOnly || formData.isPoModuleSelected === "No" || formData.throughGEM === "no"}
                  />
                  <SelectInput
                    name="billType"
                    label="Invoice Type"
                    value={formData.billType}
                    required={formData.isPoModuleSelected === "Yes"}
                    onChange={handleSelectChange}
                    options={billTypeOptions}
                    placeholder="Select"
                    disabled={isReadOnly || formData.isPoModuleSelected === "No"}
                  />
                  <SelectInput
                    name="billCategory"
                    label="Invoice Category"
                    value={formData.billCategory}
                    onChange={handleSelectChange}
                    options={formData?.isPoModuleSelected === 'Yes' ? billCategoryInvoiceOptions : billCategoryOptions}
                    placeholder="Select"
                    disabled={isReadOnly}
                  />
                  <SelectInput
                    name="procurementType"
                    label="Procurement Type"
                    value={formData.procurementType}
                    onChange={handleSelectChange}
                    options={procurementTypeOptions}
                    placeholder="Select"
                    disabled={isReadOnly || formData.isPoModuleSelected === "No" || !formData?.vendor_code}
                  />
                  {/* PO/Contract */}
                  <PoSelectionDropdown
                    vendorCode={formData?.vendor_code}
                    value={formData?.poContract}
                    onChange={handlePoSelectChangePO}
                    disabled={isReadOnly || formData.isPoModuleSelected === "No"}
                    isRequired={formData.isPoModuleSelected === "Yes"}
                    user="vendor"
                    isEmpSidePO
                    procurementType={formData.procurementType}
                    isEditMode={isEditMode}
                    module={formData?.isPoModuleSelected}
                  />
                  <TextInput name="dakNo" label="DAK No." value={formData.dakNo} onChange={handleInputChange} placeholder="Enter DAK No." disabled={isReadOnly} />
                  <LocationDropdown formData={formData} handleSelectChange={handleSelectChange} isReadOnly={isReadOnly} isMM={formData?.isPoModuleSelected === "Yes"} />
                  <DivisionDropdown formData={formData} handleSelectChange={handleSelectChange} isReadOnly={isReadOnly} isMM={formData?.isPoModuleSelected === "Yes"} />
                  {isOpen && (
                    <SelectInput
                      name="assignedTo"
                      label="Assign To"
                      value={formData.assignedTo}
                      onChange={handleSelectChange}
                      options={emphodList}
                      placeholder="Assign To"
                      disabled={isReadOnly || formData.isPoModuleSelected === "No"}
                      required={formData.isPoModuleSelected === "No"}
                    />
                  )}

                  {!isOpen && <SelectInput
                    name="treds_payment"
                    label="Treds Payment"

                    value={formData.treds_payment}
                    onChange={handleSelectChange}
                    options={trendsCodeList}
                    placeholder="Select"
                    disabled={isReadOnly || tradsListOdata?.d?.results[0]?.Visible !== "X"}
                  />}

                  <TextareaInput
                    name="remarks"
                    label="Remarks"
                    value={formData.remarks}
                    maxLength={500}
                    onChange={handleInputChange}
                    placeholder="Enter remarks"
                    disabled={isReadOnly}
                    minRows={2}
                    formControlSx={{ gridColumn: { xs: "1", sm: "1 / -1" } }}
                  />
                </Box>

                {isReadOnly && tredsDetails?.data?.Zrefid && <Box sx={{ p: 2, display: 'flex', gap: '30px' }}>
                  <div><b>TReDS Ref. ID:</b> {tredsDetails?.data?.Zrefid} </div>
                  <div><b>TReDS Inv. Status:</b> {tredsDetails?.data?.Zstatus}</div>
                </Box>}
              </Sheet>

              <BtsFinancialDetailsSection
                formData={formData}
                handleCurrencyOnBlur={(e) => handleCurrencyOnBlur(e, setFormData)}
                handleInputChange={handleInputChange}
                isReadOnly={isReadOnly}
                sectionHeaderStyles={sectionHeaderStyles}
              // isEditMode={isEditMode}
              />

              <OtherAttachments
                formData={formData}
                btsNo={invoiceDetails?.bts_no}
                handleFileChange={handleOtherFileChange}
                handleFileClick={handleFileDownload}
                onHandleDeleteRow={onHandleDeleteRow}
                isReadOnly={isReadOnly}
              />
              {formData?.approver_remarks && (
                <div>
                  <b>Remarks for Rejection:</b> {formData?.approver_remarks}
                </div>
              )}
              {billsData && (
                <MaterialThemeProvider theme={muiThemeFinal}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography component="span">Approval Logs</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ApprovalLogsDrowdown id={billsData?.id} />
                    </AccordionDetails>
                  </Accordion>
                </MaterialThemeProvider>
              )}
              <Box sx={{ marginBottom: "50px" }}></Box>

              {!isReadOnly && (
                <Box
                  sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    bgcolor: "background.surface",
                    boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
                    p: 1.5,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1.5,
                    zIndex: 1100,
                  }}
                >
                  <Button color="primary" variant="soft" onClick={handleSubmit} loading={isSubmittingEmployeeEntry} className="heading-4">
                    {isEditMode ? "Submit" : "Submit for Approval"}
                  </Button>
                </Box>
              )}
            </Box>
          </div>
        </Box>
        <FeedbackModals open={isOpenFeedbackModal} setOpen={setIsOpenFeedbackModal} handleClose={() => navigate("/employee-bills")} />
      </CssVarsProvider>
      <SuccessModal data={successModalOpen} setData={setSuccessModalOpen} handleClose={() => navigate("/employee-bills")} />
      {/* <EmployeeModal isOpen={isOpen} setIsOpen={setIsOpen}/> */}
    </>
  );
};
